import script from "./EventIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventIcon.vue?vue&type=script&lang=ts&setup=true"

import "./EventIcon.vue?vue&type=style&index=0&id=55cca79a&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55cca79a"]])

export default __exports__